(function () {
  'use strict';
  if (window.FixOEMCartState) return;
  var fetchCart = window.fetch.bind(window);
  var version = 0, pending = null, value = null, updated = 0;
  function valid(cart) { return cart && Array.isArray(cart.items) && typeof cart.item_count === 'number' && typeof cart.total_price === 'number'; }
  function copy(cart) { return JSON.parse(JSON.stringify(cart)); }
  function invalidate() { version++; value = null; updated = 0; pending = null; }
  function accept(cart) {
    if (!valid(cart)) return false;
    invalidate();
    value = copy(cart);
    updated = Date.now();
    return true;
  }
  function read() {
    if (value && Date.now() - updated < 1500) return Promise.resolve(copy(value));
    if (pending) return pending.promise.then(copy);
    var request = { version: version };
    var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    request.promise = fetchCart(root + 'cart.js', {
      credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' }
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed: ' + response.status);
      return response.json();
    }).then(function (cart) {
      if (request.version !== version) return read();
      if (!valid(cart)) throw new Error('Invalid cart response');
      value = copy(cart);
      updated = Date.now();
      return cart;
    }).finally(function () {
      if (pending === request) pending = null;
    });
    pending = request;
    return request.promise.then(copy);
  }
  window.FixOEMCartState = { read: read, invalidate: invalidate, accept: accept };
}());
